module.exports = __webpack_public_path__ + "static/media/Xh.f4d389bb.png";